import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import NumberFormat from 'react-number-format';

import useFormValidator from 'useFormValidator';

import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { reactSelectCustomStyleCms, toUpperCaseAll } from 'helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

import { InputTemplate } from "../../../../../common/components/inputComponents";

function UpdateModal({
  updateMiscFeeSettingsFees,
  getMiscFeeSettingsFeesList,
  getMiscFeeSettingsOfficeList,
  officeList,
  history,
  showMiscFeeSettingsFees,
  updateList,
  id,
  getRoleList,
  creating,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(() => {
    if (updateList) {
      return {
        office_id: String(_.get(updateList, "office_id")),
        account_title: _.get(updateList, "account_title"),
        fund_types: _.get(updateList, "fund_types"),
        ppsas_code: _.get(updateList, "ppsas_code"),
        account_code: _.get(updateList, "account_code"),
        amount: _.get(updateList, "amount"),
      }
    }
    return c.FORMS
  })

  const validateForm = useFormValidator(formData, {
    office_id: 'required',
    account_code: 'required',
    account_title: 'required',
    amount: 'required',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    getRoleList();
    getMiscFeeSettingsFeesList()
    getMiscFeeSettingsOfficeList()
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      ...c.IS_ACTIVE,
    }

    // UPDATE
    updateMiscFeeSettingsFees(id, JSON.parse(JSON.stringify(args), toUpperCaseAll), () => {
      setModal({ isOpen: false });
      getMiscFeeSettingsFeesList();
      history.push(`/miscellaneous-fees/settings/fees/${id}`);
      showMiscFeeSettingsFees(id);
    });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
  };

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeCheckbox = e => {
    return setFormData({
      ...formData,
      fund_types: {
        ...formData.fund_types,
        [e.target.name]: e.target.checked ? 1 : 0
      }
    });
  }

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const getofficeListOptions = () => {
    const officeListOptions = officeList || []
    return officeListOptions?.map(option => ({
      value: _.toUpper(_.get(option, "id")),
      label: _.toUpper(_.get(option, "attributes.name")),
    })) || [{ value: '', label: '' }]
  }

  const MAX_VAL = 9999999999999999.99;
  const withValueCap = inputObj => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="full-group-v2">
          <div className="form-row">
            <InputTemplate
              title="Fees Name"
              htmlFor="account_title"
              containerClassName="col-12"
              formValidatorMsg={validateForm.renderMessage("account_title")}
              // Input component props
              placeholder=""
              className="full-input-v2 text-uppercase"
              id="account_title"
              name="account_title"
              type="text"
              onChange={onChange}
              value={_.get(formData, 'account_title') || ''}
            />
            <InputTemplate
              title="Account Code"
              htmlFor="account_code"
              containerClassName="col-12"
              // Input component props
              placeholder=""
              className="full-input-v2 text-uppercase"
              id="account_code"
              name="account_code"
              type="text"
              onChange={onChange}
              value={_.get(formData, 'account_code') || ''}
            />
            <InputTemplate
              title="PPSAS Code"
              htmlFor="ppsas_code"
              containerClassName="col-12"
              // Input component props
              placeholder=""
              className="full-input-v2 text-uppercase"
              id="ppsas_code"
              name="ppsas_code"
              type="text"
              onChange={onChange}
              value={_.get(formData, 'ppsas_code') || ''}
            />
            <div className="d-flex flex-row flex-fill">
              <div className="col-4">
                <input
                  name="gf"
                  type="checkbox"
                  className="check-box"
                  checked={_.get(formData, 'fund_types.gf')}
                  onChange={onChangeCheckbox}
                />
                <label className="mb-0 ml-2 mt-2 text-black font-weight-bold">GF</label>
              </div>
              <div className="col-4">
                <input
                  name="tf"
                  type="checkbox"
                  className="check-box"
                  checked={_.get(formData, 'fund_types.tf')}
                  onChange={onChangeCheckbox}
                />
                <label className="mb-0 ml-2 mt-2 text-black font-weight-bold">TF</label>
              </div>
              <div className="col-4">
                <input
                  name="sef"
                  type="checkbox"
                  className="check-box"
                  checked={_.get(formData, 'fund_types.sef')}
                  onChange={onChangeCheckbox}
                />
                <label className="mb-0 ml-2 mt-2 text-black font-weight-bold">SEF</label>
              </div>
            </div>
            <InputTemplate
              isSelect
              title="Office Involved"
              htmlFor="office_id"
              containerClassName="col-12"
              formValidatorMsg={validateForm.renderMessage("office_id")}
              // Input component props
              placeholder=""
              styles={reactSelectCustomStyleCms()}
              className="full-input text-uppercase"
              id="office_id"
              name="office_id"
              type="text"
              onChange={handleOnChangeSelect('office_id')}
              options={getofficeListOptions()}
              value={getofficeListOptions().find((item) => _.get(formData, "office_id") === _.get(item, "value")) || { value: '', label: '', id: '' }}
              components={{ IndicatorSeparator: () => null }}
            />
            <InputTemplate
              title="Amount"
              htmlFor="amount"
              containerClassName="col-12"
              formValidatorMsg={validateForm.renderMessage("amount")}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="Amount"
                  id="amount"
                  placeholder="PHP 0.00"
                  className="full-input-v2"
                  style={{ minWidth: '450px'}}
                  onValueChange={values => {
                    const { floatValue } = values
                    setFormData(() => ({
                      ...formData,
                      amount: floatValue,
                    }));
                  }}
                  isAllowed={withValueCap}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix="PHP "
                  value={_.get(formData, 'amount', '')?.toString() || ''}
                />
              )} 
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}


UpdateModal.propTypes = {
  getMiscFeeSettingsFeesList: PropTypes.instanceOf(Function).isRequired,
  officeList: PropTypes.instanceOf(Object).isRequired,
  updateMiscFeeSettingsFees: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showMiscFeeSettingsFees: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  getMiscFeeSettingsOfficeList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  officeList: _.get(api, `${c.GET_MISC_FEE_SETTINGS_OFFICES_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_MISC_FEE_SETTINGS_FEES) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
